<template>
  <div class="home-container">
    <div class='home'>

      <div style='width : 500px'>
        <v-row
          class='mb-5'
          justify="space-around"
        >
          <v-img
            max-width="400"
            src='https://storage.googleapis.com/donorconnection-df169.appspot.com/newlogo.png'
          />
        </v-row>
        <v-select
          :loading='loading'
          :items="item"
          @change="route"
          label="Please select a non-profit from the list"
          outlined
        ></v-select>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  mounted() {
    this.$axios
      .get(
        "https://us-central1-donorconnection-df169.cloudfunctions.net/partnerapi/nonprofitList"
      )
      .then((response) => {
        this.itemsData = response.data;
        this.item = this.itemsData.map((item) => item.name);
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    route(item) {
      var id = this.itemsData.find((e) => e.name === item);
      this.$axios
        .get(
          "https://us-central1-donorconnection-df169.cloudfunctions.net/partnerapi/preparetoRoute/" +
            id.id
        )
        .then((response) => {
          this.$router.push({
            path: "/donation/" + id.id + "/" + response.data[0],
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  data: () => ({
    loading: true,
    item: [],
    itemsData: [],
  }),
};
</script>

<style scoped>
.home-container {
  background-image: url("https://storage.googleapis.com/donorconnection-df169.appspot.com/ezgif-6-a7648c1668d6.webp");
  width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.home {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  align-items: center;
  padding: 15px;
}
</style>